import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Check({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Check.Outline {...props} /> : <Check.Solid {...props} />;
}

Check.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M8.84267 17.6617C8.29467 17.6617 7.74667 17.4517 7.32333 17.0283L2.09067 11.7957C1.24467 10.9497 1.24467 9.58033 2.09067 8.73633C2.93667 7.89033 4.304 7.88633 5.15 8.73033L8.84267 12.4217L18.85 2.41433C19.696 1.56833 21.0633 1.56833 21.9093 2.41433C22.7553 3.26033 22.7553 4.62967 21.9093 5.47567L10.362 17.0283C9.93867 17.4517 9.39067 17.6617 8.84267 17.6617Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Check.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M8.84267 17.6617C8.29467 17.6617 7.74667 17.4517 7.32333 17.0283L2.09067 11.7957C1.24467 10.9497 1.24467 9.58033 2.09067 8.73633C2.93667 7.89033 4.304 7.88633 5.15 8.73033L8.84267 12.4217L18.85 2.41433C19.696 1.56833 21.0633 1.56833 21.9093 2.41433C22.7553 3.26033 22.7553 4.62967 21.9093 5.47567L10.362 17.0283C9.93867 17.4517 9.39067 17.6617 8.84267 17.6617Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
